import React, { useState } from "react";
import { Modal } from "reactstrap";
import closeIcon from "../../../assets/images/close.svg";
import { useChangePasswordMutation } from "../../../features/auth/authApiSlice";
import { selectCurrentUser } from "../../../features/auth/authSlice";
import { useSelector } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const ChangePassword = ({ modalOpen, toggleModal }) => {
  const [error, setError] = useState(null);

  const [changePassword, { isLoading }] = useChangePasswordMutation();
  const user = useSelector(selectCurrentUser);

  const handleSubmit = async (event) => {
    event.preventDefault(); 

    const currentPassword = event.target.elements.currentPassword.value;
    const newPassword = event.target.elements.newPassword.value;
    const newPasswordAgain = event.target.elements.newPasswordAgain.value;
    const userId = user.userID;

    if (newPassword !== newPasswordAgain) {
      setError({
        isError: true,
        message: "New Passwords don't match",
      });
      return;
    }

    const passwordPattern = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}$/;
    if (!passwordPattern.test(newPassword)) {
      setError({
        isError: true,
        message:
          "New Password must contain at least 8 characters, one symbol, one digit and one capital letter",
      });
      return;
    }

    try {
      const data = await changePassword({
        userId,
        currentPassword,
        newPassword,
      }).unwrap();
      toast.success(data.message);
    } catch (error) {
      setError({ isError: true, message: error.data.message });
      return;
    }

    setError(null);
    event.target.reset();
    toggleModal();
  };

  const closeModal = () => {
    setError(null);
    toggleModal();
  };
  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        className="modal-dialog-centered rounded"
      >
        {isLoading && <LoadingSpinner />}
        <div className="bg-nav p-2 rounded">
          <div className="header-gradient p-2 child rounded d-flex justify-content-between mb-2">
            <h6 className="modal-title" id="title">
              Change Password
            </h6>
            <button
              type="button"
              className="closeBtn"
              aria-label="Close"
              onClick={closeModal}
            >
              <img src={closeIcon} style={{ width: "70px" }} alt="" />
            </button>
          </div>
          <div className="bg-white p-2">
            <form className="p-2" onSubmit={handleSubmit}>
              {error?.isError ? (
                <div className="alert alert-warning" role="alert">
                  {error?.message}
                </div>
              ) : (
                ""
              )}
              <div className="form-group">
                <label htmlFor="currentPassword" className="text-muted">
                  Current Password
                </label>
                <input
                  id="currentPassword"
                  type="password"
                  className="form-control custom-input"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="newPassword" className="text-muted">
                  New Password
                </label>
                <input
                  id="newPassword"
                  type="password"
                  className="form-control custom-input"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="newPasswordAgain" className="text-muted">
                  New Password again
                </label>
                <input
                  id="newPasswordAgain"
                  type="password"
                  className="form-control custom-input"
                  required
                />
              </div>
              <button type="submit" className="btn btn-gradient w-100">
                Submit
              </button>
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ChangePassword;
